import { Injectable } from '@angular/core';
import instructions from '../../config/instructions.json';
import translations from '../../config/translations.json';
import { StateService } from './state.service';
import { LoadConfigService } from './load-config.service';
import { ConfigApiService } from './config-api.service';

@Injectable({
  providedIn: 'root',
})
export class InstructionService {
  private lngIdentifier: string;
  _instructions = JSON.parse(JSON.stringify(instructions));
  _translations = JSON.parse(JSON.stringify(translations));

  constructor(
    private stateService: StateService,
    private configService: LoadConfigService,
    private configApiService: ConfigApiService
  ) {}

  async setInstructions(file){
    this._instructions = file
  }

  async setTranslations(file){
    this._translations = file
  }

  getInstructions(lng: string = 'EN') {
    return this._instructions[this.getLanguageIdentifier()];
  }

  getReplacementInstructions(lng: string = 'EN') {
    return this._instructions['replacements'][this.getLanguageIdentifier()];
  }

  getTranslations() {
    return this._translations;
  }

  getTranslationsForLanguage(lng: string = 'EN') {
    return this.getTranslations()[this.getLanguageIdentifier()];
  }

  getTranslationsForTerm(term: string, lng: string = 'EN') {
    const translations = this.getTranslationsForLanguage(
      this.getLanguageIdentifier()
    );

    if (typeof translations === 'undefined') {
      return this.getDefaultTranslationsForTerm(term);
    }

    return translations[term] || this.getDefaultTranslationsForTerm(term);
  }

  getDefaultTranslations() {
    return {
      OVERVIEW_TITLE: 'Agenda',
      OVERVIEW_PART: 'Part',
      OVERVIEW_INTRODUCTION_TITLE: 'Introduction',
      OVERVIEW_QUESTIONNAIRE_TITLE: 'Questionnaire',
      OVERVIEW_FINAL_TITLE: 'Final',
      STUDY_START_CONTINUE_BUTTON: 'Start the Study',
      INSTRUCTION_CONTINUE_BUTTON: 'Go',
      OVERVIEW_CONTINUE_BUTTON: 'Continue with next Block',
      CONSENT_FORM_BUTTON: 'Continue',
      MEDIA_CONTINUE_BUTTON: 'Back to Test',
      MEDIA_INSTRUCTION: {
        pdf: 'Please read the following article.',
        image: 'Please carefully look at the following image.',
      },
      WELCOME_PAGE_HAS_QUESTIONNAIRE:
        '<p>The test is divided into two parts:</p>',
      WELCOME_PAGE_NO_QUESTIONNAIRE: '<p>The test consists of one part:</p>',
      WELCOME_PAGE_QUESTIONNAIRE_DESCRIPTION:
        'In the second part, we would like to ask you a few quick questions about yourself.',
      WELCOME_PAGE_IAT_DESCRIPTION:
        'In the first part, we would like you to perform a few decision tasks.',
      OUTRO_FINISH_STUDY: {
        BEFORE_LINK: 'Please click',
        IN_LINK: 'here',
        AFTER_LINK: 'to finish the study',
      },
      READING_MODE_CONTINUE_BUTTON: 'Continue',
      INTERMISSION_CONTINUE_BUTTON: 'Continue',
      IAT_OR_IMAGES: 'or images',
      IAT_CATEGORIES_DIFFERENTIATE: {
        images: '-related images',
      },
      IAT_PRACTICE_BLOCK:
        '<p>In order for you to get used to the task, we start the a practice run.</p>',
      IAT_WRONG_KEY_PRESS_INSTRUCTION:
        '<p>If you press the wrong key a red X will appear. Press the other key in order to continue.</p>',
      QUESTIONNAIRE_PLACEHOLDER_TEXT: 'Please enter your answer here...',
      QUESTIONNAIRE_SELECT_PLACEHOLDER: 'Please select your answer',
      QUESTIONNAIRE_SUBMIT_BUTTON_LABEL: 'Submit',
      SLIDER_WARNING: 'Please select the correct value',
      or: 'or',
      MINUTES: 'minutes',
      BLOCK_MAPPING: {
        '0': 'first',
        '1': 'second',
        '2': 'third',
        '3': 'fourth',
        '4': 'fifth',
        '5': 'sixth',
        '6': 'seventh',
        '7': 'eight',
        '8': 'ninth',
        '9': 'tenth',
        '10': 'eleventh',
        '11': 'twelfth',
        '12': 'thirteenth',
        '13': 'fourteenth',
        '14': 'fifteenth',
        last: 'last',
      },
    };
  }

  private getDefaultTranslationsForTerm(term: string) {
    const defaultTranslations = this.getDefaultTranslations();
    return defaultTranslations[term];
  }

  getLanguageIdentifier() {
    if (typeof this.lngIdentifier === 'undefined') {
      this.setLanguage();
    }

    return this.lngIdentifier;
  }

  setLanguage() {
    const params = this.configApiService.getParams()
    console.log(`Params object from configApiService: ${JSON.stringify(params)}`);
    const userLng = params === undefined ? undefined : params.lng;
    const userCountry = params === undefined ? undefined : params.country;

    console.log(`userLng: ${userLng}`);
    console.log(`userCountry: ${userCountry}`);

    if (translations.hasOwnProperty(`${userLng}_${userCountry}`)) {
      this.lngIdentifier = `${userLng}_${userCountry}`;
    } else if (translations.hasOwnProperty(userLng)) {
      this.lngIdentifier = userLng;
    } else {
      this.lngIdentifier = this.configService.getDefaultLanguage();
    }
  }
}
